import PlayerView from './views/PlayerView.vue'
import CuerpoTecnicoView from './views/CuerpoTecnicoView.vue'
import PlayerCreateView from './views/PlayerCreateView.vue'
import CuerpoTecnicoCreateView from './views/CuerpoTecnicoCreateView.vue'
import PlayerListView from './views/PlayerListView.vue'
import CuerpoTecnicoListView from './views/CuerpoTecnicoListView.vue'
import ContractCreateView from './views/ContractCreateView'
import ContractView from './views/ContractView'
import AddendaCreateView from './views/AddendaCreateView'

export default [
  {
    path: '/jugador-detalle/:id/:idClub',
    name: 'detalleJugador',
    component: PlayerView
  },
  {
    path: '/cuerpo-tecnico-detalle/:id/:idClub',
    name: 'detalleCuerpoTecnico',
    component: CuerpoTecnicoView
  },
  {
    path: '/jugador-nuevo',
    name: 'nuevoJugador',
    component: PlayerCreateView
  },
  {
    path: '/cuerpo-tecnico-nuevo',
    name: 'nuevoCuerpoTecnico',
    component: CuerpoTecnicoCreateView
  },
  {
    path: '/jugador-editar/:id/:idClub',
    name: 'editarJugador',
    component: PlayerCreateView
  },
  {
    path: '/cuerpo-tecnico-editar/:id/:idClub',
    name: 'editarCuerpoTecnico',
    component: CuerpoTecnicoCreateView
  },
  {
    path: '/contrato-nuevo/:id',
    name: 'nuevoContrato',
    component: ContractCreateView
  },
  {
    path: '/contrato-editar/:id/:idContract',
    name: 'editarContrato',
    component: ContractCreateView
  },
  {
    path: '/contrato-detalle/:id',
    name: 'detalleContrato',
    component: ContractView
  },
  {
    path: '/jugadores',
    name: 'jugadores',
    component: PlayerListView
  },
  {
    path: '/cuerpo-tecnico',
    name: 'cuerpoTecnico',
    component: CuerpoTecnicoListView
  },
  {
    path: '/adenda-nueva/:id',
    name: 'nuevaAdenda',
    component: AddendaCreateView
  },
  {
    path: '/adenda-editar/:id/:idAddendum',
    name: 'editarAdenda',
    component: AddendaCreateView
  }
]
